import type { WorkflowActivity, WorkflowActivityPage } from '../model';
import type { WorkflowActivityPort } from '../port';

export function latestWorkflowRevision(activities: WorkflowActivity[]) {
  return [...activities].reverse().find(activity => activity.kind === 'DECISION' && activity.action === 'CHANGES_REQUESTED');
}

/** 최신 페이지부터 조회하며, 각 페이지 안의 활동은 오래된 순서로 반환됩니다. */
export async function loadWorkflowActivityPages(
  port: Pick<WorkflowActivityPort, 'listWorkflowRequestActivities'>,
  requestID: string,
  { knownIDs = new Set<string>(), includeLatestRevision = false, signal }: {
    knownIDs?: ReadonlySet<string>;
    includeLatestRevision?: boolean;
    signal?: AbortSignal;
  } = {},
): Promise<WorkflowActivityPage> {
  let cursor = '';
  const seenCursors = new Set<string>();
  const data: WorkflowActivity[] = [];
  let foundKnownActivity = knownIDs.size === 0;
  let foundRevision = !includeLatestRevision;
  while (true) {
    signal?.throwIfAborted();
    const page = await port.listWorkflowRequestActivities(requestID, cursor, 50);
    signal?.throwIfAborted();
    data.push(...page.data);
    foundKnownActivity ||= page.data.some(activity => knownIDs.has(activity.id));
    foundRevision ||= Boolean(latestWorkflowRevision(page.data));
    if (!page.nextCursor || (foundKnownActivity && foundRevision)) return { data, nextCursor: page.nextCursor };
    if (seenCursors.has(page.nextCursor)) throw new Error('활동 이력의 다음 페이지를 확인하지 못했습니다. 다시 불러와 주세요.');
    seenCursors.add(page.nextCursor);
    cursor = page.nextCursor;
  }
}
